// src/pages/Team.js
import React from "react";
import { Link } from "react-router-dom";
import "./team.css";
import { MdEmail, MdPhone, MdAddLocationAlt } from "react-icons/md";

const Team = () => {
  const teamMembers = [
    {
      name: "林煒銘",
      grade: "臺北商業大學資訊與決策科學碩士班一年級",
      image: "https://cdn.wming.space/%E5%9C%960.png", 
      intro: "大眾交通工具我只服台北捷運"
    },
    {
      name: "涂雅筑",
      grade: "臺北商業大學資訊與決策科學碩士班一年級",
      image: "https://cdn.wming.space/neco.png",
      intro: "不會開車騎車的路痴，只搭乘大眾運輸工具，希望臺灣的交通狀況能改善。 \n 喜歡跟電腦相處，辭職後跑去念非本科系的研究所，在老師們的春風化雨下，邊學邊做。"
    },
    {
      name: "黃子芸",
      grade: "臺北商業大學資訊與決策科學碩士班一年級",
      image: "https://cdn.wming.space/%E5%9C%962.jpg",
      intro: "自從拿到駕照後，就成為眾人口中的三寶，借鏡過往的事故投入比賽，讓世界上的行人及駕駛者更安全。 \n 專業：豐富的生活經驗，因此能觀察到更人性的層面，突然冒出新創意。"
    },
    {
      name: "李幸恩",
      grade: "臺北商業大學資訊與決策科學碩士班一年級",
      image: "https://cdn.wming.space/%E5%9C%963.png",
      intro: "曾任3年軟體QA工程師  \n 專長：AI、金融科技、測試工程 \n 負責項目：創意發想、簡報製作。"
    }
  ];

  return (
    <div className="team-container">
      <div className="team-content">
        {/* 團隊介紹區塊 */}
        <section className="team-intro-section">
          <div className="team-intro-content">
            <h1>請退出門擋區再感應票卡</h1>
            <p className="team-description">
            請握扶手，站穩踏階 逼逼 <br />
            電扶梯上不要奔跑 逼逼 <br />
            請勿倚靠車門邊 逼逼 <br />
            關門時請勿靠近 逼逼 <br />
            小心月臺間隙 逼逼 <br />
            請往車廂內部移動，以利其他旅客上下車 逼逼 <br />
            請發揮愛心，將座位優先禮讓給需要的旅客 逼逼  <br />
            請勿吸煙、飲食、嚼食口香糖或檳榔 逼逼 <br />
            </p>
          </div>
          <div className="intro-image">
            <img src="https://cdn.wming.space/%E8%83%8C1.png" alt="團隊介紹圖片" />
          </div>
          <div className="divider"></div>
        </section>

        {/* 成員介紹區塊 */}
        <section className="team-members-section">
          <h2>團隊成員</h2>
          <div className="members-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="member-card">
                <div className="member-image">
                  <img src={member.image} alt={member.name} />
                </div>
                <div className="member-info">
                  <h3>{member.name}</h3>
                  <p className="member-grade">{member.grade}</p>
                  <p className="member-intro">{member.intro}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* 聯絡資訊區塊 */}
      <section className="contact-section">
        <h2>聯絡我們</h2>
        <div className="contact-info">
          <a href={`mailto:11366008@ntub.edu.tw`} className="contact-item">
            <MdEmail className="contact-icon" />
            <p>Email</p>
            <p>11366008@ntub.edu.tw</p>
          </a>
          {/* <a href={`tel:0233222777`} className="contact-item">
            <MdPhone className="contact-icon" />
            <p>電話</p>
            <p>(02) 3322-2777</p>
          </a> */}
          <a 
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent("台北市中正區濟南路一段321號")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-item"
          >
            <MdAddLocationAlt  className="contact-icon" />
            <p>地址</p>
            <p>台北市中正區濟南路一段321號</p>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Team;
